import { configureStore } from '@reduxjs/toolkit';
import categoryTableSlice from './reducers/categoryTableSlice';
import customerTableSlice from './reducers/customerTableSlice';
import enquiryTabelSlice from './reducers/enquiryTabelSlice';
import orderTableSlice from './reducers/orderTableSlice';
import productTableSlice from './reducers/productTableSlice';
import authSlice from './reducers/authSlice';
import appSlice from './reducers/appSlice';
import dashboardSlice from './reducers/dashboardSlice';
import paymentHistorySlice from './reducers/paymentHistorySlice';
import campaignSlice from './reducers/campaignSlice';
import analyticSlice from './reducers/analyticSlice';
import companyslice from './reducers/companySlice';
import paymentSlice from './reducers/paymentSlice';
import templateSlice from './reducers/templateReducer/templateSlice';
import messageSlice from './reducers/ShareMessage/messageSlice';
import enqChatSlice from './reducers/enqChatSlice';
import accountSlice from './reducers/accountSlice';
import ticketTabelSlice from './reducers/ticketTabelSlice';
import usageTabelSlice from './reducers/usageTabelSlice';
import mediaTableSlice from './reducers/mediaTabelSlice';
import multiInputSlice from './reducers/multiInputSlice';
import canvasSlice from './reducers/canvas/canvasSlice';
import notificationSlice from './reducers/notificationSlice';
import aiSlice from './reducers/aiSlice';
import marketPlaceSlice from './reducers/marketPlaceSlice';
import officenoteSlice from './reducers/officenoteSlice';
import officetimeSlice from './reducers/officetimeSlice';
import whiteLabelSlice from './reducers/whitelabelSlices';
import meetingSlice from './reducers/meetingSlice';
import waba_profile_slice from './reducers/waba-profile/waba-profile-slice';
import salesSupportSlice from './reducers/wca/sales-support/sales-support-slice';
import telegramSlice from './reducers/telegram/telegram-slice';
import tagSlice from "./reducers/tagslices";


const store = configureStore({
  reducer: {
    productTable: productTableSlice,
    categoryTable: categoryTableSlice,
    orderTable: orderTableSlice,
    enquiryTable: enquiryTabelSlice,
    customerTable: customerTableSlice,
    ticketTable: ticketTabelSlice,
    authenticate: authSlice,
    application: appSlice,
    dashboard: dashboardSlice,
    paymentHistory: paymentHistorySlice,
    campaign: campaignSlice,
    analytic: analyticSlice,
    company: companyslice,
    payment: paymentSlice,
    template: templateSlice,
    shareMessage: messageSlice,
    enqChats: enqChatSlice,
    account: accountSlice,
    media: mediaTableSlice,
    notification: notificationSlice,
    multiInput: multiInputSlice,
    canvas: canvasSlice,
    ai: aiSlice,
    usageTable: usageTabelSlice,
    marketPlace: marketPlaceSlice,
    officeNote: officenoteSlice,
    officeTime: officetimeSlice,
    whitelabel: whiteLabelSlice,
    meeting: meetingSlice,
    wabaProfile: waba_profile_slice,
    wcaEnqChats: salesSupportSlice,
    telegram: telegramSlice,
    tag: tagSlice,
  },
});

export default store;
